import { Box, Link, Typography, useTheme } from "@mui/material";
import BreadCrumbNumber from "./BreadCrumbNumber";

export const BreadCrumb = ({ active, number, label, onClick }) => {
  const theme = useTheme();
  const textColor =
    active >= number ? theme.palette.primary.main : theme.palette.grey.light;

  const handleClick = (n) => {
    if (onClick) onClick(n);
  };

  return (
    <Link underline="hover" color="inherit" onClick={() => handleClick(number)}>
      <Box display="flex">
        <BreadCrumbNumber active={active} number={number} />
        <Typography variant="body1" color={textColor}>
          {label}
        </Typography>
      </Box>
    </Link>
  );
};
